var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homde_head"},[_c('div',{staticClass:"head-title"},[_vm._v("智慧工厂数字孪生系统")]),_c('div',{staticClass:"jlcmLog"},[_vm._v("SUMHOO")]),_c('div',{staticClass:"userIcon"}),_c('div',{staticClass:"login"},[_vm._v("Admin")])])
}]

export { render, staticRenderFns }